import React from "react";

import { ANCHOR_IDS } from "@typings/anchorIds";

import { Container } from "@components/Layout/Container";
import { Section } from "@components/Layout/Section";

import img from "./pattern.webp";
import * as Styled from "./Reviews.styled";
import { Rating } from "./Rating";
import { Feedbacks } from "./Feedbacks";

export const Reviews = () => {
  return (
    <Section
      id={ANCHOR_IDS.REVIEWS}
      color="grey900"
      backgroundColor="green600"
      backgroundImage={`url(${img})`}
      overflowHidden
    >
      <Container>
        <Styled.Root>
          <Rating />
          <Feedbacks />
        </Styled.Root>
      </Container>
    </Section>
  );
};
